import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { DynamicFormTemplateRoutingModule } from './dynamicformtemplate-routing.module';
import { DynamicFormTemplateComponent } from './dynamicformtemplate.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
    declarations: [
        DynamicFormTemplateComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        DynamicFormTemplateRoutingModule,
        NgxExtendedPdfViewerModule

    ],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class DynamicFormTemplateModule { }
